// extracted by mini-css-extract-plugin
export var activityContainer = "_mo-0";
export var typingIndicatorContainer = "_mo-1";
export var typingIndicatorDot = "_mo-2";
export var wave = "_mo-3";